import { IEventSystem } from "@dhx/ts-common/events";

export interface IColorpicker {
	events: IEventSystem<ColorpickerEvents>;
	destructor(): void;
	paint(): void;
	focusValue(value: string): void;
	setValue(value: string): void;
	getValue(): string;
	getCustomColors(): string[];
	setCustomColors(customColors: string[]): void;
	setCurrentMode(view: ViewsTypes): void;
	getCurrentMode(): ViewsTypes;

	// TODO: remove sute_7.0
	getView(): ViewsTypes;
	setView(view: ViewsTypes): void;
}
export interface IColorpickerConfig {
	css?: string;
	paletteOnly?: boolean;
	grayShades?: boolean;
	pickerOnly?: boolean;

	customColors?: string[];
	palette?: string[][];
	width?: string;
}
export enum ColorpickerEvents {
	change = "change",
	selectClick = "selectClick",
	cancelClick = "cancelClick",
	viewChange = "viewChange",

	// TODO: remove sute_7.0
	colorChange = "colorChange"
}
export interface IEventHandlersMap {
	[key: string]: (...args) => any;
	[ColorpickerEvents.change]: (color: string) => void;
	[ColorpickerEvents.selectClick]: () => void;
	[ColorpickerEvents.cancelClick]: () => void;
	[ColorpickerEvents.viewChange]: (view: ViewsTypes) => void;

	// TODO: remove sute_7.0
	[ColorpickerEvents.colorChange]: (color: string) => void;
}
export interface IHSV {
	h: number;
	s: number;
	v: number;
}
export interface IPickerState {
	hsv: IHSV;
	currentView: ViewsTypes;
	customHex: string;
	background?: string;
	rangeLeft?: number;
}
export enum ViewsTypes {
	palette = "palette",
	picker = "picker"
}